import { normalizeBoolean } from '@change-corgi/config/fcm/normalizers';

import { createFcmConfig } from '../shared/factory';

export const FCM_STARFISH_HOMEPAGE_V2 = createFcmConfig('starfish_homepage_v2', {
	normalizer: normalizeBoolean,
	defaultValue: false,
});
